import { ToastContainer } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import Header from "../pages/include/Header";
import Sidebar from "../pages/include/Sidebar";
import axios from 'axios';

axios.interceptors.request.use(
    (req) => {
        req.headers.Authorization = 'Bearer ' + sessionStorage.getItem('accessToken');
        return req;
    },
    (err) => {
        if (err.response.status === 401) {
        }
        return Promise.reject(err);
    }
);

axios.interceptors.response.use(
    (res) => {
        res.headers.Authorization = 'Bearer ' + sessionStorage.getItem('accessToken');
        return res;
    },
    (err) => {
        if (err.response.status === 401) {
        }
        return Promise.reject(err);
    }
);

const AdminLayout = ({ component: Component }) => {
    const navigate = useNavigate();
    const isLogin = sessionStorage.getItem('accessToken');
    
    useEffect(() => {
        if (!isLogin) {
            navigate('/');
        }
    }, [isLogin, navigate]);
    
    if (!isLogin) {
        return null; 
    }
    
    return (
        <div className="main-wrapper">
            <Header />
            <Sidebar />
            <div className="page-wrapper">
                <div className="content container-fluid">
                    {Component}
                </div>
            </div>
            <ToastContainer />
        </div>
    )
};

export default AdminLayout;  